import { render, staticRenderFns } from "./DtCourse.vue?vue&type=template&id=4e95a8d3&"
import script from "./DtCourse.vue?vue&type=script&lang=js&"
export * from "./DtCourse.vue?vue&type=script&lang=js&"
import style0 from "./DtCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports